import { Text, Stack, VStack } from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box, useTheme } from 'native-base';
import React, { useMemo } from 'react';

import { RiskRating } from '../../../../../../../../../../../components/RiskRating';
import { ItemDetailsComponentProps } from '../../types';

export const ClubsDetailsContent: React.FC<ItemDetailsComponentProps> = ({
  details,
  isLoading,
}) => {
  const theme = useTheme();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const detailItems = useMemo(
    () => [
      {
        label: 'Gestor',
        value: details?.managerNameNormalized,
      },
      {
        label: 'Aplicação inicial',
        value: details?.minimumApplicationNormalized,
      },
      {
        label: 'Perfil de risco',
        value: (
          <RiskRating
            currentRiskRating={details?.riskRatingLevelNormalized || 0}
            tooltip={details?.riskRatingNormalized || ''}
          />
        ),
      },
      {
        label: 'Condição de resgate',
        value: `Cotização em D+${details?.redemptionQuotationDays} e liquidação em D+${details?.redemptionSettlementDays} após a data de cotização.`,
      },
      {
        label: 'Condição de aplicação',
        value: `Cotização em D+${details?.applicationQuotationDays}`,
      },
      {
        label: 'Movimentação mínima',
        value: details?.minimumMovementNormalized,
      },
      {
        label: 'Data de liquidação',
        value: details?.settlementDateNormalized,
      },
      {
        label: 'Data de cotização',
        value: details?.quotationDateNormalized,
      },
    ],
    [details]
  );

  const spacing = Utils.Token.ToInt(theme.space, 'stack.xxxs');

  return (
    <VStack paddingTop="inset.md">
      <Box
        display="flex"
        borderRadius="sm"
        padding="inset.nano"
        backgroundColor="background"
        style={{
          rowGap: isMobile ? undefined : spacing,
          columnGap: isMobile ? spacing : undefined,
        }}
        flexDirection={{ base: 'column', md: 'row' }}
        flexWrap={{ md: 'wrap' }}>
        {detailItems.map((item, index) => (
          <Stack
            key={`detail-item-${index}`}
            width={{ base: '100%', md: '25%' }}
            space="stack.quarck">
            <Text variant="semibold" fontSize="xs">
              {item.label}
            </Text>
            <Text isLoading={isLoading}>{item.value}</Text>
          </Stack>
        ))}
      </Box>
    </VStack>
  );
};
